<template>
  <v-card class="mb-3" color="grey lighten-4">
    <v-card-title>Day {{ day }}</v-card-title>
    <v-card-text>
      <v-list>
        <draggable :list="services" group="services" @change="onDragChange">
          <v-list-item v-for="service in services" :key="service.uid">
            <v-list-item-icon>
              <v-icon>{{ supplierTypeIcon(service.serviceType) }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>
                <v-container fluid py-0>
                  <v-row>
                    {{ service.supplierName }} - {{ service.serviceName }} -
                    Duration:&nbsp;
                    <v-edit-dialog>
                      <strong>{{ service.duration }}</strong>
                      <template v-slot:input>
                        <v-text-field
                          v-model="service.duration"
                          type="number"
                          label="Edit"
                          single-line
                          min="1"
                          :max="itemMaxDuration(service.serviceType)"
                        ></v-text-field>
                      </template>
                    </v-edit-dialog>
                  </v-row>
                  <v-row v-if="isExpanded(service)">
                    <v-col cols="12" class="py-0">
                      <div
                        v-for="extra in service.extras"
                        :key="extra.id || extra.extraId"
                        class="d-flex align-center pl-4 py-1"
                      >
                        <v-icon small class="mr-2">mdi-subdirectory-arrow-right</v-icon>
                        <span class="mr-2">{{ extra.name }}</span>
                        <confirmation-dialog
                          :item="service"
                          @onConfirm="onExtraRemove(extra, service)"
                        >
                          <v-btn small icon class="mx-0">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-icon small color="pink" v-on="on">mdi-delete</v-icon>
                              </template>
                              <span>Remove Extra</span>
                            </v-tooltip>
                          </v-btn>
                          <p slot="message">This will remove the extra.</p>
                        </confirmation-dialog>
                      </div>
                    </v-col>
                  </v-row>
                </v-container>
              </v-list-item-title>
            </v-list-item-content>

            <v-list-item-action>
              <v-row align="center">
                <v-btn
                  text
                  small
                  icon
                  v-if="service.extras && service.extras.length > 0"
                  @click="toggleExtras(service)"
                >
                  <v-icon color="yellow darken-2">mdi-star</v-icon>
                </v-btn>
                <v-btn icon small class="mx-0" @click="onServiceRemarks(service)">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon small color="primary" v-on="on"
                        >mdi-note-outline</v-icon
                      >
                    </template>
                    <span>Remarks</span>
                  </v-tooltip>
                </v-btn>
                <v-btn icon small class="mx-0" @click="onServiceDelete(service)">
                  <v-icon small color="pink">mdi-delete</v-icon>
                </v-btn>
                <v-btn icon>
                  <v-icon color="grey lighten-1">mdi-drag</v-icon>
                </v-btn>
              </v-row>
            </v-list-item-action>
          </v-list-item>
        </draggable>
      </v-list>
      <div v-if="debug">
        <code>{{ services.map((item) => item.supplierName) }}</code>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import draggable from "vuedraggable";
import { SupplierTypeIconMixin } from "../../../../mixins/SupplierTypeIconMixin";
import ConfirmationDialog from "../../shared/ConfirmationDialog";

export default {
  name: "open-group-builder-day-by-day-item",

  props: {
    day: {
      type: Number,
      default: () => 1,
    },
    groupItems: {
      type: Array,
      default: () => [],
    },
    duration: {
      type: Number,
      default: () => 1,
    },
  },

  mixins: [SupplierTypeIconMixin],

  components: { draggable, ConfirmationDialog },

  data() {
    return {
      debug: false,
      services: [...this.groupItems.filter((item) => item.startDay == this.day)],
      expanded: [],
    };
  },

  methods: {
    onDragChange(payload) {
      this.$emit("change", {
        day: this.day,
        order: this.services.map((item) => item.uid),
        ...payload,
      });
    },
    onServiceDelete(service) {
      this.$emit("delete", { ...service });
    },
    onServiceRemarks(service) {
      this.$emit("onItemRemarks", service);
    },
    itemMaxDuration(type) {
      let maxDuration = this.duration - this.day;
      if (type != "ACCOMMODATION") {
        maxDuration++;
      }
      if (maxDuration == 0) {
        maxDuration = 1;
      }
      return maxDuration;
    },
    toggleExtras(item) {
      const index = this.expanded.indexOf(item.uid);
      if (index === -1) {
        this.expanded.push(item.uid);
      } else {
        this.expanded.splice(index, 1);
      }
    },
    isExpanded(item) {
      return this.expanded.includes(item.uid);
    },
    onExtraRemove(extra, item) {
      this.$emit("onExtraRemove", { extra, item });
    },
  },

  watch: {
    groupItems(newItems) {
      this.services = [...newItems.filter((item) => item.startDay == this.day)];
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/open-groups/builder/OpenGroupBuilderDayByDayItem.vue